'use strict';

/**
 * 
 * Class for holding "questionnaire-answer-agree-disagree-nae" value set 
 * options for answering question. 
 * 
 * @see: http://www.documental.ee/questionnaire-answer-agree-disagree-nae
 * 
 * @note: 
 *   Basically it should implement FHIR ValueSet schema, but currently not needed. 
 *   https://www.hl7.org/fhir/valueset.html
 * 
 * with following options: 
 * - A   => Agree
 * - D   => Disagree
 * - NAE => Not able to evaluate
 * 
 */


function AgreeDisagreeNae() {
  
  this.id    = "questionnaire-answer-agree-disagree-nae";
  this.url   = "http://www.documental.ee/questionnaire-answer-agree-disagree-nae";
  this.name  = "Agree, Disagree and Not able to evaluate answer options for question";
  
  this.optionValues = [
    {
      code: "A",
      display: "Agree"
    },
    {
      code: "D",
      display: "Disagree"
    },
    {
      code: "NAE",
      display: "Not able to evaluate"
    }
  ];
  
  return this;
}


/**
 * -
 * 
 * @return Array
 */
AgreeDisagreeNae.prototype.getOptions = function( ) {
  return this.optionValues;
};


/**
 * -
 * 
 * @return Array
 */
AgreeDisagreeNae.prototype.getKeyValuePairs = function( ) {
  var vals = [];
  
  for( var i in this.optionValues ){
    vals[ this.optionValues[ i ].code ] = this.optionValues[ i ].display;
  }

  return vals;
};



export default AgreeDisagreeNae;